import { render, staticRenderFns } from "./VendorRequestDetails.vue?vue&type=template&id=4e3057aa&"
import script from "./VendorRequestDetails.vue?vue&type=script&lang=js&"
export * from "./VendorRequestDetails.vue?vue&type=script&lang=js&"
import style0 from "./VendorRequestDetails.vue?vue&type=style&index=0&id=4e3057aa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports